var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scroll-bar",
    [
      _c(
        "el-menu",
        {
          staticStyle: { "font-weight": "bold" },
          attrs: {
            mode: "vertical",
            "default-active": _vm.$route.path,
            collapse: _vm.isCollapse,
            "background-color": "#021b6d",
            "text-color": "#ffffff",
            "active-text-color": "#dfe7ff"
          }
        },
        [_c("sidebar-item", { attrs: { routes: _vm.permission_routers } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }